export default "__VITE_ASSET__DwBlCC$r__"